import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as BusinessPlantDetailActions from './business-plant-detail.actions';
import { ArkikAlertService } from 'src/app/shared/components/arkik-alert/arkik-alert.service';
import { TranslationService } from 'src/app/core/services/common/translation.service';
import { map, switchMap, catchError, take } from 'rxjs/operators';
import { from, of } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectBusinessPlantDetailByGuid } from './business-plant-detail.selectors';
import { BusinessPlantDetailStoreService } from './business-plant-detail.service';
import { ManageIdbService } from 'src/app/idb/manage-idb.service';

@Injectable()
export class BusinessPlantDetailEffects {
  constructor(
    private actions$: Actions,
    private businessPlantDetailService: BusinessPlantDetailStoreService,
    private alert: ArkikAlertService,
    private translation: TranslationService,
    private store: Store,
    private idb: ManageIdbService,
  ) {}

  loadBusinessPlantDetail$ = createEffect(() =>
    this.actions$.pipe(
      ofType(BusinessPlantDetailActions.loadBusinessPlantDetail),
      switchMap(({ BusinessPlanGuid }) =>
        this.store.select(selectBusinessPlantDetailByGuid(BusinessPlanGuid)).pipe(
          take(1),
          switchMap((detail) => {
            if (detail) {
              return of(BusinessPlantDetailActions.loadBusinessPlantDetailSuccess({ BusinessPlanGuid, detail }));
            }
            return from(this.idb.selectBusinessPlantDetail(BusinessPlanGuid)).pipe(
              catchError(() => of(null)),
              switchMap((cachedDetail) => {
                if (cachedDetail) {
                  return of(
                    BusinessPlantDetailActions.loadBusinessPlantDetailSuccess({
                      BusinessPlanGuid,
                      detail: cachedDetail,
                    }),
                  );
                }

                return this.businessPlantDetailService.getBusinessPlanDetail({ BusinessPlanGuid }).pipe(
                  switchMap((response) =>
                    from(this.idb.saveBusinessPlantDetail(response)).pipe(
                      map(() =>
                        BusinessPlantDetailActions.loadBusinessPlantDetailSuccess({
                          BusinessPlanGuid,
                          detail: response,
                        }),
                      ),
                    ),
                  ),
                );
              }),
              catchError((e) => {
                this.alert.error(e?.error?.message || this.translation.pt('views.globals.an-error-occurred'));
                return of(
                  BusinessPlantDetailActions.loadBusinessPlantDetailFailure({
                    error: e?.error?.message || this.translation.pt('views.globals.an-error-occurred'),
                  }),
                );
              }),
            );
          }),
        ),
      ),
    ),
  );

  refreshBusinessPlantDetail$ = createEffect(() =>
    this.actions$.pipe(
      ofType(BusinessPlantDetailActions.refreshBusinessPlantDetail),
      map(() => BusinessPlantDetailActions.resetBusinessPlantDetail()),
    ),
  );
}
